module.exports = __webpack_public_path__ + "img/chess_japanchess05.be9900d4.png";